import {
    getSubSpaces,
    createSubSpace as createSubSpaceService,
    updateSubSpace as updateSubSpaceService,
    deleteSubSpace as deleteSubSpaceService,
  } from "../services/subSpaces.service";
  
  // Action Types
  export const FETCH_SUBSPACES_SUCCESS = "FETCH_SUBSPACES_SUCCESS";
  export const CREATE_SUBSPACE_SUCCESS = "CREATE_SUBSPACE_SUCCESS";
  export const UPDATE_SUBSPACE_SUCCESS = "UPDATE_SUBSPACE_SUCCESS";
  export const DELETE_SUBSPACE_SUCCESS = "DELETE_SUBSPACE_SUCCESS";
  
  // Action Creators
  export const fetchSubSpaces = (filterText = '', page = 1, perPage = 10) => async (dispatch) => {
    try {
      const data = await getSubSpaces(filterText, page, perPage);
      console.log(data,"datass");
      
      dispatch({
        type: FETCH_SUBSPACES_SUCCESS,
        payload: { subspaces: data, totalSubSpaceCount: data.totalCount },
      });
    } catch (error) {
      console.error("Failed to fetch subspaces:", error);
    }
  };
  
  export const createSubSpace = (subSpace) => async (dispatch) => {
    try {
      const data = await createSubSpaceService(subSpace);
      dispatch({
        type: CREATE_SUBSPACE_SUCCESS,
        payload:{ subspaces: data, totalSubSpaceCount: data.totalCount},
      });
    } catch (error) {
      console.error("Failed to create subspace:", error);
    }
  };
  
  export const updateSubSpace = (subSpace) => async (dispatch) => {
    try {
      const data = await updateSubSpaceService(subSpace);
      dispatch({
        type: UPDATE_SUBSPACE_SUCCESS,
        payload: data,
      });
    } catch (error) {
      console.error("Failed to update subspace:", error);
    }
  };
  
  export const deleteSubSpace = (id) => async (dispatch) => {
    try {
      await deleteSubSpaceService(id);
      dispatch({
        type: DELETE_SUBSPACE_SUCCESS,
        payload: id,
      });
    } catch (error) {
      console.error("Failed to delete subspace:", error);
    }
  };
  